export default __webpack_public_path__ + "static/media/Tweeter.dc492b10.svg";